import React from 'react'
import { initializeApollo } from 'gql/client'
import { PAGINA } from 'utils/queries'
import RecuperaPasswordTemplate from '@components/templates/RecuperaPasswordTemplate/RecuperaPasswordTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

const RecuperaPasswordPage = ({ pagina }) => (
  <RecuperaPasswordTemplate pagina={pagina} type="recupera" />
)

export const getStaticProps = NextWrapper.getStaticProps(async ({ locale }) => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'recupera-password' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina },
    revalidate: 60 * 5,
  }
}, '/recupera-password')

export default RecuperaPasswordPage
